export const getSeasonFormDate = date => {
  const month = date.getMonth();
  switch (month) {
    case 11:
    case 0:
    case 1:
      return { text: 'Зима', text_en: 'Winter' };
    case 2:
    case 3:
    case 4:
      return { text: 'Весна', text_en: 'Spring' };
    case 5:
    case 6:
    case 7:
      return { text: 'Лето', text_en: 'Summer' };
    case 8:
    case 9:
    case 10:
      return { text: 'Осень', text_en: 'Autumn' };
    default:
      return undefined;
  }
};
